import { RxCollection, RxCollectionCreator, RxJsonSchema } from "rxdb"
import { UnsubmittedAttachment } from "src/util/types/dataModels/unsubmittedWork"

//region Types

export type UnsubmittedAttachmentCollection = RxCollection<UnsubmittedAttachment>

//endregion

/**
 * Schema for unsubmitted attachment collections
 */
export const unsubmittedAttachmentSchema: RxJsonSchema<UnsubmittedAttachment> = {
  title: "Attachment schema",
  description: "Attachments",
  version: 0,
  primaryKey: "id",
  type: "object",
  keyCompression: true,
  properties: {
    id: { type: "string", maxLength: 36, uniqueItems: true },
    name: { type: "string", maxLength: 255 },
    mimeType: { type: "string" },
    fileData: { type: "string" },
  },
  required: ["id", "name", "mimeType", "fileData"],
}

/**
 * A collection creator that can be passed to the database when setting up collections
 */
export const unsubmittedAttachmentCollectionCreator: RxCollectionCreator = {
  schema: unsubmittedAttachmentSchema,
}
